import { z } from 'zod/v4';
import { CaseVoucherSource, } from '../case-vouchers/index.js';
import { VoucherTypeMatcherSchema, } from '../vouchers/matcher.js';
export const getDefaultBillingModelId = (creditor, tenant) => {
    return creditor.defaultBillingModelId ?? tenant.defaultBillingModelId ?? null;
};
export var BillingReasonType;
(function (BillingReasonType) {
    BillingReasonType["VoucherDeleted"] = "VOUCHER_DELETED";
    BillingReasonType["VoucherCreated"] = "VOUCHER_CREATED";
    BillingReasonType["VoucherPatched"] = "VOUCHER_PATCHED";
    BillingReasonType["CasePatched"] = "CASE_PATCHED";
    BillingReasonType["BillingModelChanged"] = "BILLING_MODEL_CHANGED";
    BillingReasonType["BillingModelPatched"] = "BILLING_MODEL_PATCHED";
    BillingReasonType["BillingStartDateChanged"] = "BILLING_START_DATE_CHANGED";
    BillingReasonType["Reconciliation"] = "RECONCILIATION";
    BillingReasonType["InterestPeriodsChanged"] = "INTEREST_PERIODS_CHANGED";
})(BillingReasonType || (BillingReasonType = {}));
const ShareSchema = z.object({
    shareId: z.uuid(),
    feeFraction: z.number().optional(),
    toVoucherTypeId: z.string().optional(),
    toVoucherTypeIds: z.array(z.string()).optional(),
    voucherTypeIds: z.array(z.string()).optional(),
    categories: z.array(z.string()).optional(),
    caseTag: z.string().optional(),
    caseVoucherTag: z.string().optional(),
    caseVoucherSource: z.enum(CaseVoucherSource).optional(),
    forceCollectionCommissionBilling: z
        .object({
        withCaseTag: z.string(),
        voucherTypeId: z.uuid(),
    })
        .optional(),
});
export const CreateBillingModelSchema = z.object({
    name: z.string(),
    model: z.object({
        share: z.array(ShareSchema),
        voucherCategoryPriority: z.array(z.string()).optional(),
        voucherTypePriority: z.array(z.string()).optional(),
        voucherDatePriorityNewFirst: z.boolean().optional(),
        voucherTagPriority: z.array(z.string()).optional(),
        from: VoucherTypeMatcherSchema.optional(),
        exclude: VoucherTypeMatcherSchema.optional(),
        toVoucherTypeId: z.uuid(),
        clientDepositToVoucherTypeId: z.uuid(),
        preventNegativeCreditorBalance: z.boolean().optional(),
    }),
});
//# sourceMappingURL=index.js.map